import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { NotificationService } from '@/infra/services/notification';
import { QUERY_KEYS } from '@/utils/query-keys';

interface UpdateNotificationStatusParams {
	organization_id: string;
	notification_preferences: {
		type: string;
		method: string;
		enabled: boolean;
	}[];
}

const Service = NotificationService.getInstance();

export const useUpdateNotificationStatus = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: UpdateNotificationStatusParams) => Service.updateNotificationStatus(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_NOTIFICATION_STATUS]);
		},
		onError: () => {
			message.error(I18n.get('Error updating notification preferences'));
		}
	});
};
